import { useTranslation } from 'react-i18next';

import { Text } from '@/lib/v2/components';
import { Flex } from '@/lib/v2/components/Layout/Stack';
import { ProgressBar } from '@/lib/v2/components/ProgressBar';
import { SuccessIcon, WarningIcon } from '@/lib/v2/icons/outline';
import { FileWithLine } from '@/lib/v2/icons/solid';

import { Description } from '@/src/ContactsModule/components/ContactsViewInfo/ProgressCard';
import { loadingStatus } from '@/src/presentation/types/enum/importStatus.enum';

export type LoadingProps = {
  percentage: number;
  step: number;
  dataCard: Description[];
  status: loadingStatus;
};

export const LoadingNotification = ({ percentage, step, dataCard, status }: LoadingProps) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-x-0 bottom-0 z-[999] ml-4 h-16 w-96 cursor-pointer rounded-t-md bg-[#CCD7F4] p-4">
      <Flex>
        {status === loadingStatus.loading ? (
          <FileWithLine />
        ) : status === loadingStatus.ready ? (
          <SuccessIcon />
        ) : (
          <WarningIcon />
        )}
        <div className="relative top-1 w-full pl-5">
          <Flex column itemAlignment="stretch">
            <ProgressBar percentage={percentage} status={status} />
            <Flex>
              <Text>
                {status === loadingStatus.loading && percentage < 100
                  ? dataCard[step].description
                  : status === loadingStatus.ready
                  ? t('IMPORT_MAIN.fullLoad')
                  : status === loadingStatus.error && t('IMPORT_MAIN.errorLoad')}
              </Text>
              {status !== loadingStatus.error && <Text>{percentage}%</Text>}
            </Flex>
          </Flex>
        </div>
      </Flex>
    </div>
  );
};
